(() => {
  'use strict';
  if (window.noblB6LinksInstalled) return;
  window.noblB6LinksInstalled = true;
  const bundle = '/products/the-nobltravel-bundle';
  const carry = '/products/carry-on-all-in-one-swatch';
  const originalCarry = '/products/carry-on-all-in-one';
  const here = new URL(location.href);
  const path = here.pathname.replace(/\/$/, '');
  const previewTheme = here.searchParams.get('preview_theme_id');
  const isOffer = path === '/pages/bundle-6-pick-a-card' || (path === '/pages' && here.searchParams.get('view') === 'bundle-6-pick-a-card');
  const views = {
    control: 'control',
    arm1: 'bundle-6-native-arm-1',
    arm2: 'bundle-6-native-arm-2',
    arm3: 'bundle-6-arm-3-offer',
    arm4: 'bundle-6-native-arm-4'
  };
  const allowed = new Set(Object.values(views));
  const param = 'nobl_b6_return_view';
  const key = 'nobl_b6_return_v2';
  let carryView = here.searchParams.get(param);
  {
    try {
      if (allowed.has(carryView)) sessionStorage.setItem(key, carryView);
      else carryView = sessionStorage.getItem(key);
    } catch (_) {}
  }
  const currentView = () => {
    if (isOffer) return views.arm3;
    const view = new URL(location.href).searchParams.get('view');
    if (allowed.has(view)) return view;
    if (view === 'bundle-6-arm-3-cards') return views.arm3;
    return views[document.documentElement.dataset.noblBundleArm] || 'control';
  };
  function updateLinks() {
    const activeView = (path === bundle || isOffer) ? currentView() : carryView;
    if (!allowed.has(activeView)) return;
    try { sessionStorage.setItem(key, activeView); } catch (_) {}
    for (const link of document.querySelectorAll('a[href]')) {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#')) continue;
      const url = new URL(href, location.href);
      if (url.origin !== location.origin) continue;
      const target = url.pathname.replace(/\/$/, '');
      if ([carry, originalCarry].includes(target)) {
        if (target === originalCarry) url.searchParams.delete('variant');
        url.pathname = carry;
        url.searchParams.set('view', 'nobl-b6-carry-swatch');
        url.searchParams.set(param, activeView);
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
      } else if (target === bundle || target === '/products/the-nobltravel-bundle-swatch') {
        if (target !== bundle) url.searchParams.delete('variant');
        url.pathname = bundle;
        if (activeView === 'control') url.searchParams.delete('view');
        else url.searchParams.set('view', activeView);
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        url.searchParams.delete(param);
        if (activeView === views.arm3) {
          url.pathname = '/pages/bundle-6-pick-a-card';
          url.searchParams.delete('view');
          url.searchParams.delete('preview_key');
        }
      } else continue;
      if (link.href !== url.href) link.href = url.href;
    }
  }
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; updateLinks(); });
  };
  const start = () => {
    updateLinks();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('nobl:bundle-arm-ready', schedule);
    document.addEventListener('change', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

